import React from 'react';
import { useHistory } from 'react-router-dom';

import { TEACHERS_HOME_URL } from 'config/urls';

import styles from './styles.module.scss';

const NavTitle = ({ title, subtitle, Icon }) => {
  const history = useHistory();

  return (
    <div className={styles.navHeaderGroup}>
      <div className={styles.navTitleRow}>
        <button
          className={styles.backBtn}
          onClick={() => {
            history.push(TEACHERS_HOME_URL);
          }}
        >
          {Icon && <Icon className={styles.homeIcon} />}
        </button>
        <span>{title}</span>
      </div>
      <div className={styles.navSubtext}>{subtitle}</div>
    </div>
  );
};

export default NavTitle;
